//@flow
import * as React from 'react'
import type { DeimosQualityReviewContainer$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const DeimosQualityReviewContainer=(props:DeimosQualityReviewContainer$Props)=>{
    const deimos = props.deimos
    let isVisible = false

    if (deimos.reviewQuestions && deimos.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'deimosQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'deimosPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(deimos.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default DeimosQualityReviewContainer


// WEBPACK FOOTER //
// ./src/views/ProjectDeimos/DeimosQualityReviewContainer.js